// components/user/Divider.js
import React from "react";
import { useNode } from "@craftjs/core";
import { FormControl, FormLabel, Slider, Select, MenuItem } from "@material-ui/core";

export const Divider = ({
                            width,
                            color,
                            thickness,
                            style,
                            margin
                        }) => {
    const { connectors: { connect, drag }, selected, actions: { setProp } } = useNode(
        (node) => ({
            selected: node.events.selected
        })
    );

    return (
        <div ref={ref => connect(drag(ref))} style={{ margin: `${margin}px` }}>
            <hr
                style={{
                    width: `${width}%`,
                    borderTop: `${thickness}px ${style} ${color}`,
                    borderBottom: 'none',
                    borderLeft: 'none',
                    borderRight: 'none',
                }}
            />

            {selected && (
                <div style={{
                    padding: '10px',
                    marginTop: '10px',
                    background: '#f8f9fa',
                    borderRadius: '4px'
                }}>
                    <FormControl fullWidth style={{ marginBottom: '8px' }}>
                        <FormLabel>宽度 (%)</FormLabel>
                        <Slider
                            value={width}
                            step={1}
                            min={0}
                            max={100}
                            onChange={(_, value) => setProp(props => props.width = value)}
                        />
                    </FormControl>
                    <FormControl fullWidth style={{ marginBottom: '8px' }}>
                        <FormLabel>颜色</FormLabel>
                        <input
                            type="color"
                            value={color}
                            onChange={e => setProp(props => props.color = e.target.value)}
                            style={{ width: '100%', height: '30px' }}
                        />
                    </FormControl>
                    <FormControl fullWidth style={{ marginBottom: '8px' }}>
                        <FormLabel>粗细</FormLabel>
                        <Slider
                            value={thickness}
                            step={1}
                            min={1}
                            max={10}
                            onChange={(_, value) => setProp(props => props.thickness = value)}
                        />
                    </FormControl>
                    <FormControl fullWidth style={{ marginBottom: '8px' }}>
                        <FormLabel>样式</FormLabel>
                        <Select
                            value={style}
                            onChange={e => setProp(props => props.style = e.target.value)}
                        >
                            <MenuItem value="solid">实线</MenuItem>
                            <MenuItem value="dashed">虚线</MenuItem>
                            <MenuItem value="dotted">点线</MenuItem>
                        </Select>
                    </FormControl>
                    <FormControl fullWidth>
                        <FormLabel>外边距</FormLabel>
                        <Slider
                            value={margin}
                            step={1}
                            min={0}
                            max={40}
                            onChange={(_, value) => setProp(props => props.margin = value)}
                        />
                    </FormControl>
                </div>
            )}
        </div>
    );
};

Divider.craft = {
    props: {
        width: 100,
        color: "#000000",
        thickness: 1,
        style: "solid",
        margin: 10
    }
};